import { createAsyncThunk } from '@reduxjs/toolkit';
import { ProjectTemplateModel } from 'api/dto/ProjectTemplate.dto';
import { projectTemplateApi } from 'container/projectTemplateApi';
import { pulseProjectApi } from 'container/pulseProjectApi';
import { ProjectKind } from 'model/ProjectKind';
import { selectCompanyCircleId, selectCurrentProjectId } from 'reduxStore/project/projectSelector';
import { serializeError } from 'shared/utils/redux';

import { STORE_NAME } from './initialState';

export const TEMPLATE_LIBRARY_PAGE_LIMIT = 100;

const byName = (a: ProjectTemplateModel, b: ProjectTemplateModel) => a.name.localeCompare(b.name);

export const fetchTemplateLibrary = createAsyncThunk(
  `${STORE_NAME}/fetchTemplateLibrary`,
  (_: void, { getState }) =>
    projectTemplateApi
      .listPaginated({
        page: 1,
        limit: TEMPLATE_LIBRARY_PAGE_LIMIT,
        circleId: selectCompanyCircleId(getState()),
        kind: ProjectKind.PULSE_PROJECT,
      })
      .then(({ list }) => [...list].sort(byName)),
  { serializeError },
);

export const fetchTemplatePreview = createAsyncThunk(
  `${STORE_NAME}/fetchTemplatePreview`,
  ({ templateId }: { templateId: number }) => projectTemplateApi.get(templateId),
  { serializeError },
);

export const createSurveyFromTemplate = createAsyncThunk(
  `${STORE_NAME}/createSurveyFromTemplate`,
  ({ templateId }: { templateId: number }, { getState }) =>
    pulseProjectApi.createFromTemplate(selectCurrentProjectId(getState()), templateId),
  { serializeError },
);
